<script setup>
    import MainHeader from './../../components/HeaderComponent.vue';
    import { onMounted } from 'vue';
    import { ref } from 'vue';
    import { useSignupStore } from '@/stores/signup/signupStore';
    import { useLoginStore } from '@/stores/login/loginStore';
    import { useRouter } from 'vue-router';

    const loginStore = useLoginStore();
    const signupStore = useSignupStore();
    const router = useRouter();
    const userId = ref('');

    onMounted(async () => {
        // StoreからユーザーIDを取得する。
        userId.value = signupStore.UserId;

    });
    function backToLogin() {
        // Storeを初期化する。
        signupStore.reset();
        router.push({ name: 'login', query: { vid: loginStore.vendorId } });
    }
</script>

<template>
    <section id="main" class="bg login extra">
        <MainHeader />
        <div id="contents" class="medium">
            <h2>{{ $t('signupComplete.parts.pageTitle1') }}</h2>
            <h3>{{ $t('signupComplete.parts.pageInformation1') }}<br />{{ $t('signupComplete.parts.pageInformation2') }}</h3>
            <section class="form">
                <dl>
                    <!--ユーザーID-->
                    <dt style="padding-top: 20px">
                        <span>{{ $t('signupComplete.parts.dl1') }}</span>
                    </dt>
                    <dd>
                        <span class="userID">{{ userId }}</span>
                    </dd>
                </dl>
            </section>
            <ul class="btnArea">
                <li>
                    <button type="button" class="btnPrimary" @click="backToLogin">{{ $t('signupComplete.parts.button1') }}</button>
                </li>
            </ul>
        </div>
    </section>
</template>

<style></style>
